import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { money } from "./saUi";

const PS = {
  paid: "text-emerald-600", pending: "text-amber-600",
  failed: "text-rose-600", expired: "text-slate-400",
};

export default function Payments() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/payments").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="flex items-center gap-2 text-slate-400 py-12"><Loader2 className="w-5 h-5 animate-spin" /> Laden…</div>;

  return (
    <div data-testid="sa-payments">
      <div className="grid grid-cols-3 gap-4 mb-5">
        <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm">
          <p className="text-2xl font-head font-black text-emerald-600">{money(d.total_revenue)}</p>
          <p className="text-xs text-slate-500 mt-1">Totale omzet</p>
        </div>
        <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm">
          <p className="text-2xl font-head font-black">{d.paid_count}</p>
          <p className="text-xs text-slate-500 mt-1">Betaald</p>
        </div>
        <div className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm">
          <p className="text-2xl font-head font-black">{d.total_count}</p>
          <p className="text-xs text-slate-500 mt-1">Transacties</p>
        </div>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-2 overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead>
            <tr className="text-left text-slate-400 text-xs uppercase tracking-wide border-b border-slate-200">
              <th className="py-3 px-2">Datum</th><th className="px-2">Gebruiker</th><th className="px-2">Plan</th>
              <th className="px-2">Bedrag</th><th className="px-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {d.transactions.map((t) => (
              <tr key={t.session_id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="py-3 px-2 text-slate-500 text-xs">{t.created_at ? new Date(t.created_at).toLocaleString("nl-NL") : "—"}</td>
                <td className="px-2 font-bold">{t.user_name}</td>
                <td className="px-2 text-slate-600">{t.plan}</td>
                <td className="px-2">{money(t.amount, t.currency)}</td>
                <td className={`px-2 font-bold ${PS[t.payment_status] || "text-slate-400"}`}>{t.payment_status}</td>
              </tr>
            ))}
            {d.transactions.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-slate-400">Nog geen transacties.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
